/* Routes for the welcome area (Area A: servers and onboarding). Paths are relative; see src/app/routes.ts. */
import { page, type AreaRoutes } from '@/app/routes'

export const routes: AreaRoutes = {
  focus: [{ path: 'welcome', lazy: page(() => import('./pages/WelcomePage')) }],
}
